import NoResults from './NoResults'

export default NoResults
